import { render, staticRenderFns } from "./Paquete.vue?vue&type=template&id=d5b4b796&"
import script from "./Paquete.vue?vue&type=script&lang=js&"
export * from "./Paquete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports